import React, { Suspense } from "react";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { ThemeProvider } from "@mui/material";

import { setupResponseInterceptor } from "@store/middleware/api";
import { store } from "@store/store";

import { addMaximumScaleToMetaViewport, isIOS } from "@components/BottomPlayer/components/Player/helpers";
import { LegalReconsentGate } from "@components/LegalReconsentGate";
import { MaintenanceGate } from "@components/MaintenanceGate";
import { PageViewTracker } from "@components/PageViewTracker";
import { RemoveTrailingSlashRedirect } from "@components/RemoveTrailingSlashRedirect";
import { ViewAsBar } from "@components/ViewAsBar";
import { PlayerLayout } from "@layouts/PlayerLayout";
import theme from "@theme/theme";
import { ExternalScriptsLoader } from "@utils/externalScriptsLoader";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import { AccountTypeProvider } from "@/contexts/AccountTypeContext";
import { LoaderComponent } from "@/ui-kit";

import routes from "./routes";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "react-toastify/dist/ReactToastify.min.css";

setupResponseInterceptor(store);

function App() {
  const content = useRoutes(routes);

  if (isIOS()) {
    addMaximumScaleToMetaViewport();
  }

  return (
    <CookiesProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CookiesProvider>
            <AccountTypeProvider>
            <QueryParamProvider adapter={ReactRouter6Adapter}>
              <ViewAsBar />
              <ExternalScriptsLoader />
              <Suspense fallback={<LoaderComponent />}>
                <MaintenanceGate>
                  <RemoveTrailingSlashRedirect />
                  <PageViewTracker />
                  <PlayerLayout>{content}</PlayerLayout>
                  {/* Above the layout, below nothing: a migrated account confirms the
                      rewritten legal documents before any page can be used. */}
                  <LegalReconsentGate />
                  <ToastContainer />
                </MaintenanceGate>
              </Suspense>
            </QueryParamProvider>
            </AccountTypeProvider>
          </CookiesProvider>
        </ThemeProvider>
      </Provider>
    </CookiesProvider>
  );
}

export default App;
